import React, { useState } from "react";
import { Link } from "react-scroll";

export default function NavBar() {
  const [menu, setMenu] = useState("");

  const onClickMenu = () => {
    if (menu === "open") {
      setMenu("");
    } else {
      setMenu("open");
    }
  };

  const closeMenu = () => {
    if (menu === "open") {
      setMenu("");
    }
  };

  return (
    <header className={menu}>
      <nav>
        <div className="nav-content">
          <div className="nav-logo">
            <Link
              activeClass="active"
              to="section1"
              spy={false}
              smooth={true}
              offset={-80}
              duration={100}
            >
              <h2>Umang</h2>
            </Link>
          </div>
          <div className="nav-links">
            <ul>
              <Link
                activeClass="active"
                to="section2"
                spy={false}
                smooth={true}
                offset={-80}
                duration={100}
              >
                <li onClick={closeMenu}>About</li>
              </Link>

              <Link
                activeClass="active"
                to="section3"
                spy={false}
                smooth={true}
                offset={-80}
                duration={100}
              >
                <li onClick={closeMenu}>Skills</li>
              </Link>

              <Link
                activeClass="active"
                to="section4"
                spy={false}
                smooth={true}
                offset={-80}
                duration={100}
              >
                <li onClick={closeMenu}>Portfolio</li>
              </Link>

              <Link
                activeClass="active"
                to="section5"
                spy={false}
                smooth={true}
                offset={-80}
                duration={100}
              >
                <li onClick={closeMenu} id="contact">
                  Contact
                </li>
              </Link>
            </ul>
          </div>
          <div onClick={onClickMenu} className={`icon ${menu}`}>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </nav>
    </header>
  );
}
